import React, { useEffect, useState } from "react";
import "./Franchise.scss"
import CustomInput from "../../../components/CustomInput/CustomInput";
import CustomTextArea2 from "../../../components/CustomInput/CustomTextArea2";
import CustomDatePicker from "../../../components/CustomInput/CustomDatePicker";
import send from "../../../assets/send.svg"
import moment from "moment";
import CustomPhoneInput from "../../../components/CustomInput/CustomPhoneInput";
import { useSelector } from "react-redux";
import { isValidPhoneNumber } from 'react-phone-number-input';
import { franchiseFormSubmission } from "../../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { sortByOrderAscending } from "../../../../Hospitality/helper/helper";
const FranchiseForm = ({ components }) => {
    const company = useSelector((state) => state.companyData.company)

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [dob, setDob] = useState("")
    const [area, setArea] = useState("")
    const [experience, setExperience] = useState("")
    const [ipAddress, setIpAddress] = useState("")
    const [showSuccess, setShowSuccess] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const getIpAddress = async () => {
        const response = await fetch('https://api.ipify.org?format=json');
        const { ip } = await response.json();
        return ip
    };
    useEffect(() => {
        const fetchIP = async () => {
            let ip = await getIpAddress()
            setIpAddress(ip)
        }
        fetchIP()
    }, [])
    const [errors, setErrors] = useState({
        name: "",
        dob: "",
        area: "",
        experience: "",
        email: "",
        phoneNumber: ""
    });
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };

    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const is18OrOlder = () => {
        const birthDate = moment(dob, "YYYY-MM-DD");
        const todayMinus18 = moment().subtract(18, 'years');
        return birthDate.isSameOrBefore(todayMinus18, 'day');
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        const newErrors = {
            name: "",
            dob: "",
            area: "",
            experience: "",
            email: "",
            phoneNumber: ""
        };
        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        const trimmedDOB = moment(dob).format("YYYY-MM-dd").trim();
        const trimmedExp = experience.trim();
        const trimmedinterest = area.trim();
        if (trimmedName === "") {
            newErrors.name = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.name = "Please enter a valid name";
            valid = false;
        }
        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        } else if (!isValidPhoneNumber(trimmedPhone)) {
            newErrors.phoneNumber = "Please enter a valid phone number";
            valid = false;
        }
        if (trimmedDOB === "") {
            newErrors.dob = "*Required";
            valid = false;
        }
        else if (!is18OrOlder()) {
            newErrors.dob = "You need to be at least 18 years old to continue.";
            valid = false;
        }
        else if (!isValidPhoneNumber(trimmedPhone)) {
            newErrors.phoneNumber = "Please enter a valid phone number";
            valid = false;
        }
        if (trimmedinterest === "") {
            newErrors.area = "*Required";
            valid = false;
        }
        if (trimmedExp === "") {
            newErrors.experience = "*Required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    }
    const handleClear = () => {
        setArea("")
        setName("")
        setEmail("")
        setDob("")
        setPhoneNumber("")
        setExperience("")
    }
    const handleSubmit = async () => {
        let data = {
            "Type": "FRANCHISE",
            "OrganizationID": company?.OrganisationID,
            "CloudLocationID": company?.LocationID,
            "WebsiteID": company?.ID,
            "Name": name,
            "DateOfBirth": moment(dob).format("YYYY-MM-DD"),
            "AreaOfInterest": area,
            "IndustryExperience": experience,
            "StoreName": company?.Name,
            "LocationName": company?.City,
            "SubmittedAt": new Date().toISOString(),
            "Email": email,
            "Phone": phoneNumber,
            "CreatedDate": new Date().toISOString(),
            "ModifiedDate": new Date().toISOString(),
            "Status": "Pending",
            "Priority": "High",
            "date": moment().format("YYYY-MM-DD"),
            "time": moment().format("HH:mm A"),
            "source": "Website",
            "ipAddress": ipAddress,
            "userAgent": navigator.userAgent
        }
        await franchiseFormSubmission(data).then((res) => {
            if (res) {
                handleClear()
                setIsLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            }
        })
    }
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const getComponents = (component) => {
        switch (component.ID) {
            case "Header-tag":
                return <div className="Franchise-Form-wrapper-floatbtn" >
                    {component?.Props?.content}
                </div>
            case "Header":
                return <div className="Franchise-Form-wrapper-header">
                    {component?.Props?.content}

                </div>
            case "sub-Header":
                return <div className="Franchise-Form-wrapper-subheader">
                    {component?.Props?.content}

                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="Franchise-Form" id="form-container">
            <div className="Franchise-Form-wrapper">
                {sortByOrderAscending(components).map((component) => {
                    return getComponents(component)
                })}

                <div className="Franchise-Form-wrapper-container">
                    <div className="Franchise-Form-wrapper-container-flex">
                        <CustomInput
                            onChange={(e) => {
                                setName(e.target.value);
                                handleChange("name")
                            }}
                            type="text"
                            value={name}
                            error={errors.name !== ""}
                            errorText={errors.name}
                            label={"Name"}
                            required
                            icon={"user"}
                            placeholder={"Enter your full name"}
                        />
                        <CustomInput
                            onChange={(e) => {
                                setEmail(e.target.value);
                                handleChange("email")
                            }}
                            type="text"
                            value={email}
                            error={errors.email !== ""}
                            errorText={errors.email}
                            label={"Email Address"}
                            required
                            icon={"user"}
                            placeholder={"Enter your email address"}
                        />
                    </div>
                    <div className="Franchise-Form-wrapper-container-flex">
                        <CustomPhoneInput
                            required
                            label={"Phone Number"}
                            placeholder="Enter your phone number"
                            value={phoneNumber}
                            onChange={(e) => {
                                if (e === undefined) {
                                    setPhoneNumber("")
                                } else {
                                    setPhoneNumber(e)
                                }
                                handleChange("phoneNumber")

                            }}
                            error={errors.phoneNumber !== ""}
                            errorText={errors.phoneNumber}

                        />
                        <CustomDatePicker
                            onChange={(e) => {
                                setDob(e);
                                handleChange("dob")
                            }}
                            type="text"
                            value={dob}
                            error={errors.dob !== ""}
                            errorText={errors.dob}
                            label={"Date of Birth"}
                            required
                            icon={"mail"}
                            placeholder={"Enter your full name"}
                            maxDate={yesterday}
                        />
                    </div>
                    <div className="Franchise-Form-wrapper-container-flex">
                        <CustomInput
                            onChange={(e) => {
                                setArea(e.target.value);
                                handleChange("area")
                            }}
                            type="text"
                            value={area}
                            error={errors.area !== ""}
                            errorText={errors.area}
                            label={"Area of Interest"}
                            required
                            icon={"address"}
                            placeholder={"Enter your preferred location"}
                        />
                    </div>
                    <div className="Franchise-Form-wrapper-container-flex">
                        <CustomTextArea2
                            onChange={(e) => {
                                setExperience(e.target.value);
                                handleChange("experience")
                            }}
                            type="text"
                            value={experience}
                            error={errors.experience !== ""}
                            errorText={errors.experience}
                            label={"Industry Experience"}
                            required
                            icon={"work"}
                            placeholder={"Tell us about your relevant experience..."}
                        />
                    </div>
                    {showSuccess && <div className="succes-alert">
                        ✔ Your form has been submitted successfully.
                    </div>}
                    <div className="Franchise-Form-wrapper-container-button"
                        onClick={() => {

                            if (validateForm() && !isLoading) {
                                setIsLoading(true)
                                handleSubmit()
                            }
                        }}

                    >
                        {isLoading ? <div className="loader-btn " /> :
                            <img alt="" src={send} />
                        }
                        Submit Application
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FranchiseForm